import { withSearch } from '@elastic/react-search-ui';
import MultiCheckboxFilter from '../../../components/filter/MultiCheckboxFilter';

function SiteCategoriesFilter({ addFilter, removeFilter, facets, filters }) {
  return (
    <MultiCheckboxFilter
      addFilter={addFilter}
      facets={facets}
      fieldId="category"
      filters={filters}
      formHint="Select all that apply."
      id="site-category"
      label="Category"
      orderByCount={true}
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, facets, filters }) => ({
  addFilter,
  removeFilter,
  facets,
  filters,
}))(SiteCategoriesFilter);
